import { useTranslation } from 'react-i18next';

const Footer = () => {
    const { t } = useTranslation();
    
    return (
        <>
            <footer className='footer' style={{
                borderTop: '1px solid rgba(41, 98, 255, 0.25)',
                background: 'linear-gradient(180deg, rgba(10, 10, 26, 0.95) 0%, rgba(26, 26, 46, 0.98) 100%)'
            }}>
                <div className='footer-content' style={{ 
                    display: 'flex', 
                    justifyContent: 'center', 
                    alignItems: 'center',
                    padding: '1.25rem 1.5rem',
                    textAlign: 'center'
                }}>
                    <div style={{ maxWidth: '700px' }}>
                        <div style={{ 
                            fontSize: '1.5rem', 
                            marginBottom: '0.35rem',
                            filter: 'drop-shadow(0 2px 8px rgba(255, 193, 7, 0.4))'
                        }}>
                        </div>
                        <p className='font-tomorrow' style={{ 
                            fontSize: '1.0rem', 
                            lineHeight: '1.5',
                            color: '#E5E5E5',
                            margin: 0,
                            fontWeight: 400
                        }}>
                            {t('footer.notice.line1')} <br />
                            {t('footer.notice.line2')}
                        </p>
                    </div>
                </div>
            </footer>
        </>
    )
}

export default Footer;